import React, { useEffect, useRef, useState } from 'react';
import * as services from '@services/index';
import { IDoctors } from '@/schemas/operation';
import { getTargetUrl } from '@utils/url';
import { openOrDownloadUrl } from '@/utils/open-or-download-url';
import IconFont from '@/components/Iconfont';
import { cacheHandler } from '@/services/operation';
import DoctorCard from '../../components/DoctorCard';
import styles from './index.module.scss';

const RecommendDoctors: React.FC<{
  onLoad?: () => void;
}> = ({ onLoad }) => {
  const [doctors, setDoctors] = useState<IDoctors>([]);

  const isLoaded = useRef(false);

  const getDoctors = async () => {
    try {
      const data = await services.operation.getRecommendDoctors();
      setDoctors(data);
    } catch (err) {
      //
    } finally {
      if (!isLoaded.current) {
        typeof onLoad === 'function' && onLoad();
      }
    }
  };

  useEffect(() => {
    const data = cacheHandler.getRecommendDoctors.get();
    if (data?.length) {
      setDoctors(data);
      isLoaded.current = true;
      typeof onLoad === 'function' && onLoad();
    } else {
      isLoaded.current = false;
    }
    getDoctors();
  }, []);

  const handleMore = () => {
    const url = getTargetUrl(
      `${window.location.origin}/topics?layoutType=4&enableWK=1&hyId=healthy-channel`
    );
    openOrDownloadUrl(url);
  };

  return (
    <div className={styles['recommend-doctors']}>
      <div className={styles.title}>
        <h1>健康专栏</h1>
        <button type="button" onClick={handleMore}>
          <IconFont icon="common_base_next_24" />
        </button>
      </div>
      <ul className={styles['home-doctor-list']}>
        {doctors.map((doctor, index) => (
          <DoctorCard doctor={doctor} index={index} key={index} />
        ))}
      </ul>
    </div>
  );
};
export default RecommendDoctors;
